import React from "react";
import Panel from "../Panel";
import { WAREHOUSE } from "./consumableHelpers";

// Panel 8c: where consumables may be held, admin only.
//
// This is the list the setup run and the quantity editor offer. The warehouse is
// always present and cannot be removed — it is where stock with no site sits, so
// removing it would leave unissued units with nowhere to belong.
export default function StockLocations({ locations, inUse, onAdd, onRemove }) {
  const [name, setName] = React.useState("");

  const trimmed = name.trim();
  const duplicate = locations.some(l => l.toLowerCase() === trimmed.toLowerCase());
  const canAdd = !!trimmed && !duplicate;

  const add = () => {
    if (!canAdd) return;
    onAdd(trimmed);
    setName("");
  };

  return (
    <Panel title="Stock locations" sub="Admin only">
      <div style={{ fontSize: 12, lineHeight: 1.5, color: "var(--text-muted)", marginBottom: 12 }}>
        Where consumables can be held. Every location here appears in the setup run and
        the counted-stock adjuster.
      </div>

      <div>
        {[WAREHOUSE, ...locations.filter(l => l !== WAREHOUSE)].map(l => {
          const held = inUse[l] || 0;
          const fixed = l === WAREHOUSE;
          return (
            <div
              key={l}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "10px 0",
                borderBottom: "1px solid var(--border-subtle)",
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 500, color: "var(--text-primary)" }}>{l}</div>
                <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>
                  {fixed
                    ? "Always available · holds unissued stock"
                    : held > 0
                    ? held + " item" + (held === 1 ? "" : "s") + " held here"
                    : "Nothing held here"}
                </div>
              </div>
              {!fixed && (
                <button
                  type="button"
                  className="btn btn-ghost btn-sm"
                  // Removing a location that still holds stock would orphan those
                  // items, so it is blocked until the stock is moved out.
                  disabled={held > 0}
                  title={held > 0 ? "Move its stock elsewhere first" : undefined}
                  onClick={() => onRemove(l)}
                >
                  Remove
                </button>
              )}
            </div>
          );
        })}
      </div>

      <div style={{ display: "flex", gap: 6, marginTop: 14 }}>
        <input
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => {
            if (e.key === "Enter") {
              e.preventDefault();
              add();
            }
          }}
          placeholder="New stock location…"
          aria-label="New stock location"
          style={{
            flex: 1,
            height: 34,
            padding: "0 10px",
            borderRadius: 6,
            outline: "none",
            border: "1px solid var(--border-default)",
            background: "var(--surface-default)",
            color: "var(--text-primary)",
            fontFamily: "inherit",
            fontSize: 14,
          }}
        />
        <button type="button" className="btn btn-primary btn-sm" disabled={!canAdd} onClick={add}>
          Add
        </button>
      </div>
      {duplicate && (
        <div style={{ fontSize: 12, color: "var(--danger-text)", marginTop: 6 }}>
          That location is already in the list.
        </div>
      )}
    </Panel>
  );
}
